import { Listbox, ListboxButton, ListboxOption, Label, ListboxOptions } from '@headlessui/react'
export type {
  ListboxProps as HeadlessListboxProps,
  ListboxButtonProps as HeadlessListboxButtonProps,
  LabelProps as HeadlessListboxLabelProps,
  ListboxOptionProps as HeadlessListboxOptionProps,
  ListboxOptionsProps as HeadlessListboxOptionsProps
} from '@headlessui/react'

export const HeadlessListbox = Object.assign(Listbox, {
  Options: ListboxOptions,
  Option: ListboxOption,
  Label: Label,
  Button: ListboxButton
})
